<template>
  <div class="empty-dataset">
    <div
      v-if="$slots.icon"
      class="empty-dataset__icon"
    >
      <slot name="icon"></slot>
    </div>

    <h4 class="empty-dataset__title">{{ title }}</h4>

    <div class="empty-dataset__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyDataset',
  props: {
    title: {
      type: String,
      default: 'Leere',
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
/**
 * Empty Dataset
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Empty data placeholder for content areas
 * @since 2021-09-20
**/

$component: 'empty-dataset';

.#{$component} {
  @include padding(map-get($spacers, 3));
  text-align: center;

  &__icon {
    @include rfs(3.6rem, width);
    height: auto;
    @include margin(0 auto map-get($spacers, 3) auto);

    svg {
      width: 100%;
      height: auto;
      color: $ink-lighter;
    }
  }

  &__title {
    font-family: $font-family-sans-serif;
    @include font-size($font-size-lg);
    color: $ink-lighter;
    font-weight: $font-weight-normal;
  }

  &__content {
    color: $ink-lightest;
    text-align: center;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
